<script setup lang="ts">
defineProps<{
  compactView: boolean
}>()

defineEmits<{
  'update:view': [boolean]
}>()
</script>

<template>
  <div class="flex flex-wrap gap-4">
    <UButton icon="i-wilo-grid-solid-full" variant="ghost" color="tertiary" :disabled="compactView" @click="$emit('update:view', true)" />
    <UButton icon="i-wilo-list-solid-full" variant="ghost" color="tertiary" :disabled="!compactView" @click="$emit('update:view', false)" />
  </div>
</template>
